<template>
  <v-snackbar v-model="snackbar" timeout="10000">
    <b>{{ $t("addShortcutToHomeScreen.title") }}</b
    ><br />
    {{ $t("addShortcutToHomeScreen.click_icon") }} <v-icon small>mdi-export-variant</v-icon><br />
    {{ $t("addShortcutToHomeScreen.select_add") }}
    <v-switch
      :ripple="false"
      dense
      x-class="text-h4"
      v-model="notShowAgain"
      :label="$t('addShortcutToHomeScreen.not_show_again')"
    ></v-switch>

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {

  data() {
    return {
      b_snackbar: true,
      b_notShowAgain: false,
    };
  },

  computed: {
    snackbar: {
      get() {
        return this.b_snackbar && this.$appMode == 0 && this.ua_isIOS() && this.ua_isSafari() && this.$store.getters.addShortcutBarEnabled && !this.getNotShowAgain();
      },

      set(newValue) {
        this.b_snackbar = newValue;
      },
    },

    notShowAgain: {
      get() {
        return this.getNotShowAgain();
      },

      set(newValue) {
        this.b_notShowAgain = newValue;
        this.setNotShowAgain(newValue);
      },
    },
  },

  methods: {
    getNotShowAgain() {
      let notShowAgain = false;
      let key = "SNS_" + this.$store.state.appToken.CompanyCode;
      if (localStorage.getItem(key)) {
        notShowAgain = localStorage.getItem(key).toLowerCase() == "true" ? true : false;
      }

      return notShowAgain;
    },

    setNotShowAgain(notShowAgain) {
      let key = "SNS_" + this.$store.state.appToken.CompanyCode;
      localStorage.setItem(key, notShowAgain);
    },
  },
};
</script>
